export const grey = {
  50: '#ffffff',
  100: '#f4f7fb',
  200: '#dfe8f4',
  300: '#cfdced',
  400: '#b9cde7',
  500: '#bbbfcc',
  600: '#8288a0',
  700: '#51566b',
  800: '#2d2d2d',
  900: '#060606',
};

export const white = '#FFFFFF';

export const black = '#000000';

export const blue = '#2aa5ea';

export const green = '#30c78c';

export const orange = '#d1ae33';

export const red = '#dc345c';

export const primary = {
  main: '#454DCC',
  light: '#BDBFED',
  dark: '#1A1E5E',
};
